import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import dateFormatConstant from '../../../constants/dateFormatConstant';
import ConformanceTooltip from './conformanceTooltip';
import DateTimePicker from '../../common/controls/dateTimePicker';
import { conformanceSelector, enabledSelector, labelSelector, newPathSelector, valueSelector, customerConfigurationSelector } from '../selectors/index';
import entityComposition from '../../common/classes/entityComposition';
import Label from './label';
import logValueOnChange from '../commonActions/logValueOnChange';
import localChangeSelector from '../selectors/localChangeSelector';
const DateTimePickerField = _ref => {
  let _ref$conformanceText = _ref.conformanceText,
    conformanceText = _ref$conformanceText === void 0 ? null : _ref$conformanceText,
    enabled = _ref.enabled,
    _ref$label = _ref.label,
    label = _ref$label === void 0 ? null : _ref$label,
    onChange = _ref.onChange,
    _ref$testingIdentifie = _ref.testingIdentifier,
    testingIdentifier = _ref$testingIdentifie === void 0 ? 'default-id' : _ref$testingIdentifie,
    _ref$value = _ref.value,
    value = _ref$value === void 0 ? null : _ref$value,
    path = _ref.path,
    _ref$timePickerType = _ref.timePickerType,
    timePickerType = _ref$timePickerType === void 0 ? '12hr' : _ref$timePickerType,
    localChangeFunc = _ref.localChangeFunc,
    _ref$customerDateForm = _ref.customerDateFormat,
    customerDateFormat = _ref$customerDateForm === void 0 ? 'month-first' : _ref$customerDateForm;
  const dateFormat = dateFormatConstant[customerDateFormat];
  const showConformance = !!conformanceText;
  const handleChange = async updatedValue => {
    if (updatedValue !== value) {
      const d = new Date(updatedValue);
      const log = {
        path,
        value: updatedValue,
        displayValue: d.toUTCString()
      };
      await onChange(localChangeFunc(log));
    }
  };

  /**
   * Handle when picker opens with no value - set default to current date+time
   */
  const handleOpen = () => {
    if (value === null || value === undefined) {
      // Get current time and represent it as a UTC ISO string
      const now = new Date();
      const currentDateTime = now.toISOString();
      handleChange(currentDateTime);
    }
  };
  const id = "dtpf-".concat(kebabCase(label));
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    "data-testid": id
  }, /*#__PURE__*/React.createElement(Label, {
    value: label
  }), /*#__PURE__*/React.createElement(DateTimePicker, {
    viewMode: "days",
    timeFormat: timePickerType === '24hr' ? 'HH:mm' : 'h:mm A',
    disabled: !enabled,
    onChange: handleChange,
    value: value,
    onOpen: handleOpen,
    className: "".concat(showConformance ? 'is-invalid' : '', " ").concat(kebabCase(testingIdentifier), " tqc-date-time-picker-field"),
    verticalPadding: false,
    dateFormat: dateFormat
  }), /*#__PURE__*/React.createElement(ConformanceTooltip, {
    errorText: conformanceText,
    target: id
  }));
};
DateTimePickerField.propTypes = {
  conformanceText: PropTypes.string,
  enabled: PropTypes.bool.isRequired,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  path: PropTypes.string.isRequired,
  testingIdentifier: PropTypes.string,
  timePickerType: PropTypes.string,
  localChangeFunc: PropTypes.func.isRequired,
  customerDateFormat: PropTypes.string
};
export { DateTimePickerField as UncomposedDateTimePickerField };
export default entityComposition(DateTimePickerField, [], {
  conformanceText: conformanceSelector,
  enabled: enabledSelector,
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange,
  path: newPathSelector,
  localChangeFunc: localChangeSelector,
  customerDateFormat: customerConfigurationSelector
});